import { useContext } from 'react';
import { Stack } from '@mantine/core';
import { ProfileContext } from '../../Service/Context/ProfileContext';
import PanePaper from '../PanePaper';
import BookitupTextInput from '../../Atoms/inputs/BookitupTextInput';

const AdditionalInfoSettings = () => {
  const { profile, patchProfile } = useContext(ProfileContext);
  const { additionalInfo01, additionalInfo02, additionalInfo03 } = profile ?? {};

  return (
    <PanePaper title="Zusatzangaben">
      <Stack spacing="xs">
        <BookitupTextInput
          label="z.B. Amtsgericht"
          defaultValue={additionalInfo01}
          onBlurSave={(val) => patchProfile({ additionalInfo01: val })}
        />

        <BookitupTextInput
          label="z.B: Unternehmenssitz"
          defaultValue={additionalInfo02}
          onBlurSave={(val) => patchProfile({ additionalInfo02: val })}
        />

        <BookitupTextInput
          label="z.B. Geschäftsführer"
          defaultValue={additionalInfo03}
          onBlurSave={(val) => patchProfile({ additionalInfo03: val })}
        />
      </Stack>
    </PanePaper>
  );
};

export default AdditionalInfoSettings;
